import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Logger } from '_clean-code/utils/logger';
interface AnnotateStopErrorModalErrorBoundaryProps {
  children: React.ReactNode;
}

// Silent fallback component that renders nothing
const SilentFallback = () => null;

export const AnnotateStopErrorModalErrorBoundary: React.FC<
  AnnotateStopErrorModalErrorBoundaryProps
> = ({ children }) => {
  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    // Log error to console in development
    if (import.meta.env.NODE_ENV === 'development') {
      Logger.error(
        'AnnotateStopErrorModal Error Boundary caught an error:',
        error,
        errorInfo
      );
    }
  };

  return (
    <ErrorBoundary FallbackComponent={SilentFallback} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};
